// shared/shared.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisableAutofillDirective } from './disable-autofill';

@NgModule({
  declarations: [DisableAutofillDirective],
  imports: [CommonModule],
  exports: [DisableAutofillDirective],
})
export class SharedModule {}
